const BrowsersType = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Edge: "Edge",
    Safari: "Safari",
    Opera: "Opera",
};
export function checkBrowserCompatibility(agent) {
    const browserVersion = agent.browser.majorVersion;
    console.log("browserVersion", browserVersion);
    switch (agent.browser.fullName) {
        case BrowsersType.Chrome: {
            return browserVersion >= 72;
        }
        case BrowsersType.Firefox: {
            return browserVersion >= 72;
        }
        case BrowsersType.Edge: {
            return browserVersion >= 79;
        }
        case BrowsersType.Safari: {
            return browserVersion >= 13;
        }
        case BrowsersType.Opera: {
            return browserVersion >= 60;
        }
        default:
            return false;
    }
}
